
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 548 548","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M248.4 311.2l65.1-37.2-65.1-36.9z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M274 0C122.7 0 0 122.7 0 274s122.7 274 274 274 274-122.7 274-274S425.3 0 274 0zm123.7 296.7c-.9 17-2.4 29.6-4.5 37.8-1.5 5.2-4.2 9.7-8.2 13.6-3.9 3.9-8.6 6.6-14.1 8.2-7.9 2.1-26.4 3.6-55.5 4.5l-41.4.4-41.4-.4c-29.1-.9-47.7-2.4-55.5-4.5-5.5-1.5-10.1-4.2-14.1-8.2-3.9-3.9-6.6-8.5-8.2-13.6-2.1-8.2-3.6-20.8-4.5-37.8l-.4-22.8c0-6.6.1-14.2.4-22.8.9-16.7 2.4-29.1 4.5-37.3 1.5-5.5 4.2-10.1 8.2-14.1 3.9-3.9 8.6-6.6 14.1-8.2 7.9-2.1 26.4-3.6 55.5-4.5l41.4-.4 41.4.4c29.1.9 47.7 2.4 55.5 4.5 5.5 1.5 10.1 4.2 14.1 8.2 3.9 3.9 6.6 8.6 8.2 14.1 2.1 8.2 3.6 20.7 4.5 37.3l.4 22.8-.4 22.8z"}})])
          )
        }
      }
    